// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Link_link__3KPQo {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Footer/Link.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0BAA0B;AAC5B","sourcesContent":[".link {\n  cursor: pointer;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "Link_link__3KPQo"
};
export default ___CSS_LOADER_EXPORT___;
